export const STORE_STEP = "STORE_STEP";

export const STORE_ACK_NUMBER = "STORE_ACK_NUMBER";
export const STORE_ACCOUNT_TYPE = "STORE_ACCOUNT_TYPE";

export const STORE_SUBSCRIBER_DATA = "STORE_SUBSCRIBER_DATA";

export const CLEAR_NEW_SUBSCRIBER_DATA = "CLEAR_NEW_SUBSCRIBER_DATA";

export const GET_PERSONAL_DETAILS_SUCCESS = "GET_PERSONAL_DETAILS_SUCCESS";
export const GET_PERSONAL_DETAILS = "GET_PERSONAL_DETAILS";

export const SAVE_PERSONAL_DETAILS_SUCCESS = "SAVE_PERSONAL_DETAILS_SUCCESS";
export const SAVE_PERSONAL_DETAILS = "SAVE_PERSONAL_DETAILS";

export const GET_KYC_DETAILS_SUCCESS = "GET_KYC_DETAILS_SUCCESS";
export const GET_KYC_DETAILS = "GET_KYC_DETAILS";

export const SAVE_KYC_DETAILS_SUCCESS = "SAVE_KYC_DETAILS_SUCCESS";
export const SAVE_KYC_DETAILS = "SAVE_KYC_DETAILS";

export const GET_AADHAAR_DETAILS_SUCCESS = "GET_AADHAAR_DETAILS_SUCCESS";
export const GET_AADHAAR_DETAILS = "GET_AADHAAR_DETAILS";

export const SAVE_AADHAAR_DETAILS_SUCCESS = "SAVE_AADHAAR_DETAILS_SUCCESS";
export const SAVE_AADHAAR_DETAILS = "SAVE_AADHAAR_DETAILS";

export const GET_FATCA_DETAILS_SUCCESS = "GET_FATCA_DETAILS_SUCCESS";
export const GET_FATCA_DETAILS = "GET_FATCA_DETAILS";

export const SAVE_FATCA_DETAILS_SUCCESS = "SAVE_FATCA_DETAILS_SUCCESS";
export const SAVE_FATCA_DETAILS = "SAVE_FATCA_DETAILS";

export const GET_BANK_DETAILS_SUCCESS = "GET_BANK_DETAILS_SUCCESS";
export const GET_BANK_DETAILS = "GET_BANK_DETAILS";

export const SAVE_BANK_DETAILS_SUCCESS = "SAVE_BANK_DETAILS_SUCCESS";
export const SAVE_BANK_DETAILS = "SAVE_BANK_DETAILS";
export const SAVE_PENNY_DETAILS_SUCCESS = "SAVE_PENNY_DETAILS_SUCCESS";
export const SAVE_PENNY_DETAILS = "SAVE_PENNY_DETAILS";

export const GET_NOMINEE_LIST_SUCCESS = "GET_NOMINEE_LIST_SUCCESS";
export const GET_NOMINEE_LIST = "GET_NOMINEE_LIST";

export const SAVE_NOMINEE_DETAILS_SUCCESS = "SAVE_NOMINEE_DETAILS_SUCCESS";
export const SAVE_NOMINEE_DETAILS = "SAVE_NOMINEE_DETAILS";

export const GET_NPS_SCHEME_DETAILS_SUCCESS = "GET_NPS_SCHEME_DETAILS_SUCCESS";
export const GET_NPS_SCHEME_DETAILS = "GET_NPS_SCHEME_DETAILS";

export const SAVE_NPS_SCHEME_DETAILS_SUCCESS =
  "SAVE_NPS_SCHEME_DETAILS_SUCCESS";
export const SAVE_NPS_SCHEME_DETAILS = "SAVE_NPS_SCHEME_DETAILS";

export const SAVE_DOCUMENTS_SUCCESS = "SAVE_DOCUMENTS_SUCCESS";
export const SAVE_DOCUMENTS = "SAVE_DOCUMENTS";

export const GET_NPS_FUND_INVESTMENT_CHOICES =
  "GET_NPS_FUND_INVESTMENT_CHOICES";
export const GET_NPS_FUND_INVESTMENT_CHOICES_SUCCESS =
  "GET_NPS_FUND_INVESTMENT_CHOICES_SUCCESS";

export const STORE_KYC_KTRACK_DETAILS = "STORE_KYC_KTRACK_DETAILS";

export const GET_PREVIEW = "GET_PREVIEW";
export const GET_PREVIEW_SUCCESS = "GET_PREVIEW_SUCCESS";
